module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-regular.f57a62e.woff2";